import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as SuccessCheckmark } from '../../../../../assets/icons/v3/check-circle-v2.svg';
import { ReactComponent as ErrorCheckmark } from '../../../../../assets/icons/v3/xerror.svg';

import './PasswordValidations.scss';

interface IPasswordValidations {
  validation: {
    validLength: boolean;
    hasNumber: boolean;
    upperCase: boolean;
    lowerCase: boolean;
    match?: boolean;
  };
  texts: {
    description: string;
    firstCondition: string;
    secondCondition: string;
    thirdCondition: string;
  };
}

const PasswordValidations = ({ validation, texts }: IPasswordValidations) => {
  const { t } = useTranslation();

  const displayIcon = (isValid: boolean) => {
    if (isValid) {
      return (
        <SuccessCheckmark
          className="success-icon"
          aria-label="Success Checkmark"
          role="presentation"
          focusable="false"
        />
      );
    }
    return <ErrorCheckmark aria-label="Error Checkmark" role="presentation" focusable="false" />;
  };

  return (
    <div className="password-validations-container flex flex-col gap-3" data-experience="new">
      <div className="pv-description">{t(texts.description)}</div>
      <div className="flex flex-col gap-3">
        <div className={`pv-row ${validation.validLength ? 'valid' : ''}`}>
          {displayIcon(validation.validLength)}
          <div className="pv-text">{t(texts.firstCondition)}</div>
        </div>
        <div className={`pv-row ${validation.lowerCase && validation.upperCase ? 'valid' : ''}`}>
          {displayIcon(validation.lowerCase && validation.upperCase)}
          <div className="pv-text">{t(texts.secondCondition)}</div>
        </div>
        <div className={`pv-row ${validation.hasNumber ? 'valid' : ''}`}>
          {displayIcon(validation.hasNumber)}
          <div className="pv-text">{t(texts.thirdCondition)}</div>
        </div>
      </div>
    </div>
  );
};

export default PasswordValidations;
